import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Notification, { notifyApiError } from "components/Notification";
import Layout from "layouts/DashboardManage";
import Pagination from "components/Pagination";
import ManageDataTable from "components/ManageDataTable";
import {
  getAllWorkflows,
  deleteWorkflow,
  resetPayload,
  DELETE_WORKFLOW
} from "store/actions/workflowAction";
import { SpinnerRainbow } from "components/Spinner";
import Translate from "helpers/Translate";
import NoData from "components/NoData";

export class Workflow extends Component {
  state = {
    showDeleteConfirm: false
  };

  componentDidMount() {
    this.props.getAllWorkflows({
      clientId: this.props.match.params.clientId
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      notifyApiError(this.props.error);
    }

    if (this.props.deleteStatus === 200) {
      Notification.success(Translate({ id: "data_deleted_successfully" }));
      this.props.resetPayload(DELETE_WORKFLOW);
      this.props.getAllWorkflows({
        clientId: this.props.match.params.clientId,
        page: 1
      });
    }
  }

  handleDelete = (e, item) => {
    e.preventDefault();
    const id = e.currentTarget.id || item.id;
    Notification.confirm(
      Translate({ id: "sure_to_delete", values: [item.name] }),
      {
        onOk: () => {
          this.props.deleteWorkflow(id);
        }
      }
    );
  };

  onPageChange = targetPage => {
    this.props.getAllWorkflows({
      clientId: this.props.match.params.clientId,
      page: targetPage
    });
  };

  hasData = () => {
    return (
      !this.props.isLoading &&
      this.props.workflows &&
      this.props.workflows.data &&
      this.props.workflows.data.length > 0
    );
  };

  render() {
    return (
      <Layout>
        <div className="manage">
          <Link className="back mb-20" to="/manage/clients">
            <i className="fas fa-long-arrow-alt-left"></i>
            {Translate({ id: "back_to_manage_clients" })}
          </Link>
          <h1 className="title mb-20">
            {Translate({ id: "manage_workflow" })}{" "}
          </h1>
          <div className="manage-list-actions manage-list-actions--end">
            <Link
              data-test="btnadd"
              to={`/manage/clients/${this.props.match.params.clientId}/workflows/add`}
              className="btn btn-primary btn-add-manage"
            >
              <i className="fas fa-plus mr-10"></i>
              {Translate({ id: "add_workflow" })}
            </Link>
          </div>

          {this.props.isLoading && <SpinnerRainbow />}

          {!this.props.isLoading && (
            <ManageDataTable
              footer={
                this.hasData() ? (
                  <Pagination
                    onPageChange={this.onPageChange}
                    data={this.props.workflows && this.props.workflows.meta}
                  />
                ) : null
              }
            >
              <table>
                <thead>
                  <tr>
                    <th className="left">{Translate({ id: "name" })} </th>
                    <th className="action-col">
                      {Translate({ id: "action" })}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {this.hasData() &&
                    this.props.workflows.data.map(item => (
                      <tr key={item.id}>
                        <td>{item.name}</td>
                        <td className="action-col">
                          <div className="manage-data-table-actions">
                            <Link
                              className="action-btn action-edit"
                              title="Edit"
                              to={`/manage/clients/${this.props.match.params.clientId}/workflows/edit/${item.id}`}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                            <button
                              type="button"
                              className="action-btn action-delete"
                              title={Translate({ id: "delete" })}
                              id={item.id}
                              onClick={e => this.handleDelete(e, item)}
                            >
                              <i className="fas fa-trash-alt" id={item.id}></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}

                  {!this.hasData() && (
                    <tr>
                      <td colSpan="100">
                        <NoData />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </ManageDataTable>
          )}
        </div>
      </Layout>
    );
  }
}

Workflow.propTypes = {
  getAllWorkflows: PropTypes.func.isRequired,
  workflows: PropTypes.object,
  isLoading: PropTypes.bool,
  deleteStatus: PropTypes.number,
  error: PropTypes.object
};

const mapStateToProps = state => {
  return {
    workflows: state.workflow.getAllWorkflows,
    isLoading: state.workflow.isLoadingWorkflow,
    deleteStatus: state.workflow.deleteWorkflowStatus,
    error: state.workflow.errorWorkflow
  };
};

export default connect(mapStateToProps, {
  getAllWorkflows,
  deleteWorkflow,
  resetPayload
})(Workflow);
